module.exports = __webpack_public_path__ + "static/media/bretland.904e1de4.png";